import styled from 'styled-components';
import {
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div``;

const Table = styled(SemanticTable)``;

const Body = styled(Table.Body)``;

const Column = styled(Table.Cell)`

  ${({ noborder }) => (noborder ? '&&& { border-top: none; }' : '')}

  ${({ borderbottom }) => (borderbottom && (`
    &&& {
    border-bottom: solid 1px rgba(34, 36, 38, .1);
    padding: 0;
  }
  `))}
`;

const Row = styled(Table.Row)``;

const Title = styled(TextLayoutComponent.Header)`
  ${({ marginleft }) => (marginleft ? 'margin-left: 20px;' : '')}
`;

export {
  Column,
  Container,
  Table,
  Title,
  Row,
  Body,
};
